/* eslint consistent-return: "off" */
import _ from 'lodash';
import store from '@/store';
import { loadUser } from '@/modules/api/auth';
import { loadProjects } from '@/project/api';

let baseURL = window.location.origin;

if (process.env.VUE_APP_ORIGIN) {
  baseURL = process.env.VUE_APP_ORIGIN;
}

// async const loadStoreProjectsId = () => await store.getters.projectIds;

const guard = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const { teamName } = to.params;
    if (teamName) {
      loadUser(teamName)
        .then(account => store.dispatch('setCurrentUser', account.data))
        .then(() => loadProjects())
        .then(response => store.dispatch('setProjects', response.data))
        .then(() => next());
    } else {
      window.location.href = `${baseURL}/accounts/byteark`;
    }
  } else {
    return next();
  }
};

const guardProject = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresProject)) {
    let setCurrentProject = null;
    const { teamName, projectId } = to.params;
    const projects = store.getters.projectIds;
    const defaultProject = projects[0];
    const currenProject = _.find(projects, item => item === projectId);

    if (!_.isUndefined(currenProject)) {
      setCurrentProject = store.getters.getProjectById(currenProject);
    } else if (store.getters.currentProject) {
      setCurrentProject = store.getters.currentProject;
    } else if (defaultProject) {
      setCurrentProject = store.getters.getProjectById(defaultProject);
    }

    store.dispatch('setCurrentProject', setCurrentProject)
      .then(() => {
        if (to.name === 'projectCreate') {
          return next();
        }

        if (projects.length === 0 && to.name !== 'projectChrome') {
          return next(`/${teamName}/projects/`);
        }

        if (!projectId && defaultProject) {
          return next(`/${teamName}/projects/${defaultProject}`);
        }

        return next();
      });
  } else {
    return next();
  }
};

export {
  guard,
  guardProject,
};
